import React from 'react';
import Header from '../../../components/Header/Header';
import { Footer } from 'festo-react-ui-kit';
import { useAppSelector } from '../../../app/hooks';
import useTranslation from '../../../features/translation/hooks/useTranslation';

// import Header from '../../../components/Header/Header';
// import { selectBackendPathWithoutLeadingSlash } from '../../../features/base/slice';

interface ContainerProps {
  children: React.ReactNode;
}

export default function Container({ children }: ContainerProps): JSX.Element {
  const t = useTranslation();
  const { applicationType } = useAppSelector((state) => state.base);

  const showHeaderAndFooter = !(applicationType === 'fox');
  return (
    <>
      {showHeaderAndFooter && <Header />}
      {children}
      {showHeaderAndFooter && <Footer copyrightText={`${t('footerFesto')} ${t('footerCopyright')}`} links={[]} />}
    </>
  );
}
